<template>
  <Card dis-hover class="rule-card">
    <template #title>
      <div class="rule-header">{{ $t('key1002177') }}</div>
    </template>
    <Form ref="warehouseRuleModuleForm" :model="warehouseRuleModuleForm" :rules="warehouseRuleModuleRule"
      :lable-width="labelWidth" label-position="left">
      <FormItem :label="$t('key1005198')" prop="ruleName">
        <Input v-model.trim="warehouseRuleModuleForm.ruleName" clearable style="width:300px"></Input>
      </FormItem>
      <FormItem :label="$t('key1006457')" prop="ymsWarehouseId">
        <Select ref="shipAccount" v-model="warehouseRuleModuleForm.ymsWarehouseId" filterable style="width:300px">
          <Option v-for="(item,index) in shippingWarehouseList" :key="index" :value="item.ymsWarehouseId">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('key1001522')" prop="status">
        <i-switch size="large" v-model="warehouseRuleModuleForm.status" :true-value="1" :false-value="0">
          <template #open>{{ $t('key1000462') }}</template>
          <template #close>{{ $t('key1002180') }}</template>
        </i-switch>
      </FormItem>
      <Checkbox v-model="warehouseRuleModuleForm.allocateWarehouse">{{ $t('key1002179') }}</Checkbox>
    </Form>
  </Card>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllWarehouseData} from "@/utils/common";

export default {
  name: 'warehouseRuleModule',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      warehouseRuleModuleForm: {
        ruleName: '',
        status: 1,
        ymsWarehouseId: null,
        allocateWarehouse: true
      },
      warehouseRuleModuleRule: {
        ruleName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006455'), trigger: 'blur'}
        ],
        ymsWarehouseId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006456'), trigger: 'change'}
        ]
      },
      shippingWarehouseList: [],
      warehouseRuleModuleType: 'add',
      paramsKeys: 'assignWarehouse',
      autoRuleId: null,
    }
  },
  methods: {
    // 初始化数据
    initWarehouseRuleModuleData(detailsData, type) {
      this.warehouseRuleModuleType = type;
      if (detailsData) {
        let {selectedRule} = detailsData;
        let ruleActions = detailsData.ruleActions || [];
        if (ruleActions.length > 0) {
          ruleActions.map((item) => {
            if (item.type === this.paramsKeys) {
              let obj = JSON.parse(item.value);
              this.warehouseRuleModuleForm.ymsWarehouseId = obj.ymsWarehouseId || null;
              this.warehouseRuleModuleForm.allocateWarehouse = obj.matchOtherWarehouseRulesSelected;
            }
          })
        }
        this.warehouseRuleModuleForm.ruleName = selectedRule?.name || '';
        this.warehouseRuleModuleForm.status = selectedRule?.status || 1;
        this.autoRuleId = selectedRule?.autoRuleId || null;
      }
      getAllWarehouseData({servicePlatforms: ['core', 'supplier']}).then((data) => {
        let arr1 = data.filter((item) => (item.servicePlatform === 'core' && item.collectionWarehouse === 1) ||
          (item.servicePlatform === 'core' && item.stockedWarehouse === 1));
        let arr2 = data.filter((item) => (item.servicePlatform === 'supplier' && item.isDeliveryWarehouse === 1));
        let list = [...arr1, ...arr2];
        this.shippingWarehouseList = this.uniqueFunc(list, 'ymsWarehouseId');
      })
    },
    // 确定按钮
    warehouseRuleModuleBtn(params) {
      let v = this;
      let values = {
        ymsWarehouseId: v.warehouseRuleModuleForm.ymsWarehouseId,
        matchOtherWarehouseRulesSelected: v.warehouseRuleModuleForm.allocateWarehouse
      };
      let query = {
        autoRuleId: v.autoRuleId,
        autoRuleActions: [{
          type: v.paramsKeys,
          value: JSON.stringify(values)
        }],
        autoRuleItems: params,
        name: v.warehouseRuleModuleForm.ruleName,
        status: v.warehouseRuleModuleForm.status
      };
      let configMap = {
        add: {
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456'),
          url: api.post_ymsDistributorWarehouseAutoRule,
          method: 'post'
        },
        edit: {
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279'),
          url: api.put_ymsDistributorWarehouseAutoRule,
          method: 'put'
        }
      }
      const config = configMap[v.warehouseRuleModuleType];
      if (config) {
        let {method, successText, url} = config;
        v.$refs['warehouseRuleModuleForm'].validate((valid, err) => {
          if (valid) {
            v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
              if (response.data.code === 0) {
                v.$Message.success(successText);
                v.$emit('updateWarehouseRule', true);
              }
            });
          }
        });
      }
    },
    // 重置数据
    reset() {
      this.$refs['warehouseRuleModuleForm'].resetFields();
      this.warehouseRuleModuleForm.allocateWarehouse = true;
      this.autoRuleId = null;
    }
  },
};
</script>

<style lang="less" scoped>
.rule-card .ivu-card-head {
  background-color: #f7f7f7;
  height: 32px;
  padding: 0 0 0 10px;
  line-height: 32px;
}
</style>
